(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.mcgOn)return;root.dataset.mcgOn=1;
    var items=[].slice.call(root.querySelectorAll('.mcg-it')),dlg=root.querySelector('.mcg-lb');
    if(!items.length||!dlg||!dlg.showModal)return;
    var img=dlg.querySelector('.mcg-lb__img'),nm=dlg.querySelector('.mcg-lb__name'),pr=dlg.querySelector('.mcg-lb__price'),sh=dlg.querySelector('.mcg-lb__shop'),i=0,x0=null;
    function show(k){i=(k+items.length)%items.length;var d=items[i].dataset;img.style.opacity=0;img.onload=function(){img.style.opacity=1};img.src=d.src;img.alt=d.title;nm.textContent=d.title;pr.textContent=d.price;sh.href=d.url}
    items.forEach(function(b,k){b.addEventListener('click',function(){show(k);dlg.showModal();document.documentElement.style.overflow='hidden'})});
    dlg.querySelector('.mcg-lb__prev').addEventListener('click',function(){show(i-1)});
    dlg.querySelector('.mcg-lb__next').addEventListener('click',function(){show(i+1)});
    dlg.querySelector('.mcg-lb__x').addEventListener('click',function(){dlg.close()});
    dlg.addEventListener('close',function(){document.documentElement.style.overflow='';items[i].focus({preventScroll:true})});
    dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close()});
    dlg.addEventListener('keydown',function(e){if(e.key==='ArrowLeft')show(i-1);if(e.key==='ArrowRight')show(i+1)});
    dlg.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    dlg.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;x0=null;if(Math.abs(dx)>50)show(dx<0?i+1:i-1)});
  }
  function all(){document.querySelectorAll('.mcg').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-photobook-rail"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.on)return;root.dataset.on=1;
    var tr=root.querySelector('[data-mpb-track]'),bar=root.querySelector('[data-mpb-bar]'),prev=root.querySelector('[data-mpb-prev]'),next=root.querySelector('[data-mpb-next]');
    if(!tr)return;
    function step(){var it=tr.querySelector('[data-mpb-item]');return it?it.getBoundingClientRect().width+parseFloat(getComputedStyle(tr).columnGap||16):320}
    function upd(){var max=tr.scrollWidth-tr.clientWidth,p=max>0?tr.scrollLeft/max:0,vis=Math.min(1,tr.clientWidth/tr.scrollWidth)*100;
      if(bar){bar.style.setProperty('--w',vis+'%');bar.style.setProperty('--x',(p*(100-vis))+'%')}
      if(prev)prev.disabled=tr.scrollLeft<4;if(next)next.disabled=max<4||tr.scrollLeft>max-4}
    if(prev)prev.addEventListener('click',function(){tr.scrollBy({left:-step(),behavior:'smooth'})});
    if(next)next.addEventListener('click',function(){tr.scrollBy({left:step(),behavior:'smooth'})});
    tr.addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);upd();setTimeout(upd,600);
    var x0=0,sl=0,drag=false,moved=0;
    tr.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button!==0)return;drag=true;moved=0;x0=e.clientX;sl=tr.scrollLeft;tr.classList.add('is-drag');try{tr.setPointerCapture(e.pointerId)}catch(_){}});
    tr.addEventListener('pointermove',function(e){if(!drag)return;var dx=e.clientX-x0;moved=Math.max(moved,Math.abs(dx));tr.scrollLeft=sl-dx});
    function end(){if(!drag)return;drag=false;tr.classList.remove('is-drag');if(moved>6){var k=step(),t=Math.round(tr.scrollLeft/k)*k;tr.scrollTo({left:t,behavior:'smooth'})}}
    tr.addEventListener('pointerup',end);tr.addEventListener('pointercancel',end);
    tr.addEventListener('click',function(e){if(moved>6){e.preventDefault();e.stopPropagation()}moved=0},true);
    tr.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();tr.scrollBy({left:step(),behavior:'smooth'})}else if(e.key==='ArrowLeft'){e.preventDefault();tr.scrollBy({left:-step(),behavior:'smooth'})}});
  }
  function all(){document.querySelectorAll('[data-mpb]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.on)return;root.dataset.on=1;
    var tr=root.querySelector('[data-mrv-track]'),prev=root.querySelector('[data-mrv-prev]'),next=root.querySelector('[data-mrv-next]');
    if(!tr)return;
    function step(){var it=tr.querySelector('.mrv__it');return it?it.getBoundingClientRect().width+parseFloat(getComputedStyle(tr).columnGap||14):320}
    function upd(){var max=tr.scrollWidth-tr.clientWidth;if(prev)prev.disabled=tr.scrollLeft<4;if(next)next.disabled=max<4||tr.scrollLeft>max-4}
    if(prev)prev.addEventListener('click',function(){tr.scrollBy({left:-step(),behavior:'smooth'})});
    if(next)next.addEventListener('click',function(){tr.scrollBy({left:step(),behavior:'smooth'})});
    tr.addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);upd();setTimeout(upd,600);
    var x0=0,sl=0,drag=false,moved=0;
    tr.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button!==0)return;drag=true;moved=0;x0=e.clientX;sl=tr.scrollLeft;tr.classList.add('is-drag');try{tr.setPointerCapture(e.pointerId)}catch(_){}});
    tr.addEventListener('pointermove',function(e){if(!drag)return;var dx=e.clientX-x0;moved=Math.max(moved,Math.abs(dx));tr.scrollLeft=sl-dx});
    function end(){if(!drag)return;drag=false;tr.classList.remove('is-drag');if(moved>6){var k=step();tr.scrollTo({left:Math.round(tr.scrollLeft/k)*k,behavior:'smooth'})}}
    tr.addEventListener('pointerup',end);tr.addEventListener('pointercancel',end);
    tr.addEventListener('click',function(e){if(moved>6){e.preventDefault();e.stopPropagation()}moved=0},true);
    tr.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();tr.scrollBy({left:step(),behavior:'smooth'})}else if(e.key==='ArrowLeft'){e.preventDefault();tr.scrollBy({left:-step(),behavior:'smooth'})}});
  }
  function all(){document.querySelectorAll('[data-mrv]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();
})();
